import api from "../../api.js";

export async function getPendingConsultations() {
  const res = await api.get("/api/clinic/consultations/pending");
  return res.data?.data || [];
}

export async function getConsultation(consultationId) {
  const res = await api.get(`/api/clinic/consultations/${encodeURIComponent(consultationId)}`);
  return res.data?.data || null;
}

export async function getConsultationFull(consultationId) {
  const res = await api.get(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/full`);
  return res.data?.data || null;
}

export async function createConsultation(payload) {
  const res = await api.post("/api/clinic/consultations", payload);
  return res.data;
}

export async function updateConsultation(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}`, payload);
  return res.data;
}

export async function saveConsultationHistory(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/history`, payload);
  return res.data;
}

export async function saveConsultationVitals(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/vitals`, payload);
  return res.data;
}

export async function saveConsultationComplaint(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/complaint`, payload);
  return res.data;
}

export async function saveConsultationComplaintTags(consultationId, tags) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/complaint-tags`, { tags });
  return res.data;
}

export async function saveConsultationQA(consultationId, items) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/qa`, { items });
  return res.data;
}

export async function saveConsultationUrineDipstick(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/urine-dipstick`, payload);
  return res.data;
}

export async function saveConsultationDiagnosis(consultationId, items) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/diagnosis`, { items });
  return res.data;
}

export async function saveConsultationProblems(consultationId, items) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/problems`, { items });
  return res.data;
}

export async function saveConsultationTreatmentPlan(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/treatment-plan`, payload);
  return res.data;
}

export async function saveConsultationFollowup(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/followup`, payload);
  return res.data;
}

export async function updateAppointmentStatus(appointmentId, status) {
  const res = await api.put(`/api/clinic/appointments/${encodeURIComponent(appointmentId)}/status`, { status });
  return res.data;
}

export async function listConsultationHistoryPatients() {
  const res = await api.get("/api/clinic/consultation-history/patients");
  return res.data?.data || [];
}

export async function getConsultationHistoryPatient(patientId) {
  const id = patientId != null ? String(patientId) : "";
  if (!id) return null;
  const rows = await listConsultationHistoryPatients();
  const match = (Array.isArray(rows) ? rows : []).find((p) => String(p?.patientid) === id);
  return match || null;
}

export async function getNextClinicReference() {
  const res = await api.get("/api/clinic/prescriptions/next-clinic-reference");
  return res.data?.clinicReference || null;
}

export async function getPatientWithMainMemberDetails(patientId) {
  const id = patientId != null ? String(patientId) : "";
  if (!id) return null;
  const res = await api.get(`/api/clinic/patients/${encodeURIComponent(id)}/main-member-details`);
  return res.data?.data || null;
}

export async function getPatientServiceSummary(patientId) {
  const res = await api.get(`/api/clinic/consultation-history/${encodeURIComponent(patientId)}/services`);
  return res.data?.data || [];
}

export async function getPatientServiceVisitHistory(patientId, serviceId) {
  const res = await api.get(`/api/clinic/consultation-history/${encodeURIComponent(patientId)}/services/${encodeURIComponent(serviceId)}`);
  return res.data?.data || [];
}

export async function getPatientConsultationTimeline(patientId) {
  const res = await api.get(`/api/clinic/consultation-history/${encodeURIComponent(patientId)}/timeline`);
  return res.data?.data || [];
}

export async function createClinicPrescription(payload) {
  const res = await api.post("/api/clinic/prescriptions", payload);
  return res.data;
}

export async function createClinicCreditTransaction(payload) {
  const res = await api.post('/api/clinic/credittransactions', payload);
  return res.data;
}

export async function getActiveConsentTemplates() {
  const res = await api.get("/api/clinic/consent-templates");
  return res.data?.data || [];
}

export async function getConsentTemplateById(templateId) {
  const res = await api.get(`/api/clinic/consent-templates/${encodeURIComponent(templateId)}`);
  return res.data?.data || null;
}

export async function getConsultationConsents(consultationId) {
  const res = await api.get(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/consents`);
  return res.data?.data || [];
}

export async function upsertConsultationConsent(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/consents`, payload);
  return res.data;
}

export async function getConsultationServiceWorkflowData(consultationId) {
  const res = await api.get(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/workflow-data`);
  return res.data?.data || null;
}

export async function upsertConsultationServiceWorkflowData(consultationId, payload) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/workflow-data`, payload);
  return res.data;
}

export async function saveConsultationServices(consultationId, services) {
  const res = await api.put(`/api/clinic/consultations/${encodeURIComponent(consultationId)}/services`, { services });
  return res.data;
}
